import React, { useState, useEffect, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import { applyDrag } from "../../../helpers/index";
import config from "../../../baseConfig/index";
import {
  localStorageSetItem,
  localStorageGetItem,
  localStorageRemoveItem,
} from "../../../storage/index";
import {
  trans,
  setSpaceAfterNLetter,
  doubleNumber,
} from "../../../helpers/index";
import { Container, Draggable } from "react-smooth-dnd";
import ApiManager from "../../../apiManager/index";
import FormMiddlewareError from "../../Fragments/FormMiddlewareError";
import EditForm from "../../Fragments/EditForm";
import DetachModal from "../../Fragments/DetachModal";
import ReactNotification from "react-notifications-component";
import ErrorModal from "../../Fragments/ErrorModal";
import Modal from "../../Fragments/Modal";
import Loading from "../../Fragments/Loading";
import {
  ArmenianFlagConst,
  EyeComponent,
  OTPInput,
} from "../../UIComponents/UIComponents";

function Account(props) {
  const [profileData, setProfileData] = useState("");
  const [profileNumber, setProfileNumber] = useState("");
  const [profileEmail, setProfileEmail] = useState("");
  const [profileButtonDisabled, setProfileButtonDisabled] = useState(false);
  const [profileFormResponse, setProfileFormResponse] = useState("");
  const [usernameForVerification, setUsernameForVerification] = useState("");
  const [userEmailForVerification, setUserEmailForVerification] = useState("");
  const [changePasswordOld, setChangePasswordOld] = useState("");
  const [changePasswordNew, setChangePasswordNew] = useState("");
  const [changePasswordRepeat, setChangePasswordRepeat] = useState("");
  const [changePasswordButtonDisabled, setChangePasswordButtonDisabled] =
    useState(false);
  const [changePasswordFormResponse, setChangePasswordFormResponse] =
    useState("");
  const [changePasswordMinLength] = useState(8);

  const [toggleAttachedNumbers, setToggleAttachedNumbers] = useState(false);
  const [verificationErrors, setVerificationErrors] = useState({
    number: "",
    email: "",
  });
  const [isShowOldPassword, setIsShowOldPassword] = useState("");
  const [isShowNewPassword, setIsShowNewPassword] = useState("");
  const [isShowRepeatPassword, setIsShowRepeatPassword] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [verificationTimeLife, setVerificationTimeLife] = useState(-1);

  const [dnd1, setDnd1] = useState(
    localStorageGetItem("accountDnd1") || [0, 1]
  );
  const [dnd2, setDnd2] = useState(
    localStorageGetItem("accountDnd2") || [2, 3]
  );
  const [dnd3, setDnd3] = useState(
    localStorageGetItem("accountDnd3") || [4, 5, 6]
  );

  const [detachModal, setDetachModal] = useState(false);
  const [detachNumber1, setDetachNumber1] = useState("");
  const [detachNumber2, setDetachNumber2] = useState("");
  const [currentToken, setCurrentToken] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false);

  const [cardButtonDisabled, setCardButtonDisabled] = useState(false);
  const [paymentCardList, setPaymentCardList] = useState("");

  const [autoPaymentList, setAutoPaymentList] = useState("");
  const [autoPaymentAskModal, setAutoPaymentAskModal] = useState(false);
  const [currentVerificationField, setCurrentVerificationField] = useState("");
  const [
    autoPaymentAskModalButtonDisabled,
    setAutoPaymentAskModalButtonDisabled,
  ] = useState(false);
  const [isShowVerificationOPT, setIsShowVerificationOPT] = useState(false);
  const [paymentCardDeleteId, setPaymentCardDeleteId] = useState(null);
  const [paymentCardDeleteModalShow, setPaymentCardDeleteModalShow] =
    useState(false);
  const [
    paymentCardDeleteModalButtonDisabled,
    setPaymentCardDeleteModalButtonDisabled,
  ] = useState(false);

  const isMounted = useRef(false);
  const notificationDOMRef = useRef(null);
  useEffect(() => {
    if (profileData?.data) {
      setUsernameForVerification(profileData.data.username);
      setUserEmailForVerification(profileData.data.email);
    }
  }, [profileData]);

  useEffect(() => {
    isMounted.current = true;
    initAsyncCalls();

    return () => {
      isMounted.current = false;
    };
  }, []);

  const blocksCount = useMemo(() => {
    return [...dnd1, ...dnd2, ...dnd3].length;
  }, []);

  useEffect(() => {
    if (blocksCount < 7) {
      setDnd1([6, ...dnd1]);
    }
  }, [blocksCount]);

  useEffect(() => {
    if (props.parentState.switchAccount) {
      setProfileData("");
      setProfileNumber("");
      setProfileEmail("");
      setPaymentCardList("");
      setAutoPaymentList("");
      initAsyncCalls();
    }
  }, [props.parentState.switchAccount]);

  const addNotification = (inMessage, type) => {
    if (!isMounted.current || !notificationDOMRef.current) return;
    notificationDOMRef.current.addNotification({
      title: "",
      message: inMessage,
      type: type || "success",
      insert: "top",
      container: "top-right",
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: { duration: 2000 },
      dismissable: { click: true },
    });
  };

  const initAsyncCalls = () => {
    ApiManager.getRequest({ jwt: props.getDecryptedToken() }, "/profile").then(
      profileSuccess,
      errorCallBack
    );

    getCardList();
    getAutoPaymentsList();
  };

  const getAutoPaymentsList = () => {
    ApiManager.getRequest(
      { jwt: props.getDecryptedToken() },
      "/autopayment/list"
    ).then(autoPaymentListSuccess, errorCallBack);
  };

  const getCardList = () => {
    ApiManager.getRequest(
      { jwt: props.getDecryptedToken() },
      "/payment/card/list"
    ).then(paymentCardListSuccess, errorCallBack);
  };

  const profileSuccess = (resolve) => {
    if (!isMounted.current || resolve.data.status !== "OK") return;
    setProfileData(resolve.data);
    setProfileNumber(resolve.data.data.contact_number);
    setProfileEmail(resolve.data.data.contact_email);
  };

  const paymentCardListSuccess = (resolve) => {
    if (!isMounted.current) return;
    setPaymentCardList(resolve.data);
  };

  const autoPaymentListSuccess = (resolve) => {
    if (!isMounted.current) return;
    setAutoPaymentList(resolve.data);
  };

  const errorCallBack = () => {
    setShowErrorModal(true);
  };
  const sendProfileData = (event) => {
    event.preventDefault();
    setProfileButtonDisabled(true);

    ApiManager.postRequest(
      {
        jwt: props.getDecryptedToken(),
        _token: props.csrf_token.data,
        contact_number: profileNumber,
        contact_email: profileEmail,
      },
      "/profile/update"
    ).then((resolve) => {
      if (!isMounted.current) return;
      setProfileButtonDisabled(false);
      setProfileFormResponse(resolve.data);

      if (resolve.data.status === "OK") {
        addNotification(resolve.data.message);
      } else {
        addNotification(resolve.data.message, "danger");
      }
    }, errorCallBack);
  };

  const changePasswordAction = (event) => {
    event.preventDefault();
    setChangePasswordButtonDisabled(true);

    ApiManager.postRequest(
      {
        old_password: changePasswordOld,
        password: changePasswordNew,
        password_confirmation: changePasswordRepeat,
        jwt: props.getDecryptedToken(),
        _token: props.csrf_token.data,
      },
      "/change-password"
    ).then((resolve) => {
      if (!isMounted.current) return;
      setChangePasswordButtonDisabled(false);
      setChangePasswordFormResponse(resolve.data);

      if (resolve.data.status === "OK") {
        setChangePasswordOld("");
        setChangePasswordNew("");
        setChangePasswordRepeat("");
        addNotification(
          trans(props.trans, "account.password_change.success.message")
        );
      }
    }, errorCallBack);
  };

  const verificationHandler = () => {
    return ApiManager.postRequest(
      {
        jwt: props.getDecryptedToken(),
        _token: props.csrf_token.data,
        msisdn: usernameForVerification,
      },
      "/profile/number/verify"
    );
  };

  const emailVerifivationHandler = () => {
    return ApiManager.postRequest(
      {
        jwt: props.getDecryptedToken(),
        _token: props.csrf_token.data,
        email: userEmailForVerification,
      },
      "/profile/email/verify"
    );
  };

  const emailVerificationHandlerSubmit = (event) => {
    return ApiManager.postRequest(
      {
        jwt: props.getDecryptedToken(),
        _token: props.csrf_token.data,
        token: currentToken,
        code: verificationCode,
      },
      "/profile/email/update"
    );
  };

  const verificationHandlerSubmit = (event) => {
    return ApiManager.postRequest(
      {
        jwt: props.getDecryptedToken(),
        _token: props.csrf_token.data,
        token: currentToken,
        code: verificationCode,
      },
      "/profile/number/update"
    );
  };

  const changeMyAccountName = (event) => {
    event.preventDefault();

    ApiManager.postRequest(
      {
        jwt: props.getDecryptedToken(),
        _token: props.csrf_token.data,
        name: props.parentState.editMyAccountName,
      },
      "/account/me/update"
    ).then(editMyAccountNameSuccess, errorCallBack);
  };

  const editMyAccountNameSuccess = (resolve) => {
    if (!isMounted.current) return;
    props.updateParentState({
      editMyAccountNameResponse: resolve.data,
      editMyAccount: resolve.data.status !== "OK",
      editedMyAccountName:
        resolve.data.status === "OK" ? props.parentState.editMyAccountName : "",
    });
  };

  const changeOfficeName = (event, id) => {
    event.preventDefault();

    ApiManager.postRequest(
      {
        jwt: props.getDecryptedToken(),
        _token: props.csrf_token.data,
        name: props.parentState.editOfficesList[id]["name"],
        id: id,
      },
      "/account/update"
    ).then((resolve) => {
      if (!isMounted.current) return;
      changeOfficeNameSuccess(resolve, id);
    }, errorCallBack);
  };

  const changeOfficeNameSuccess = (resolve, id) => {
    if (!isMounted.current) return;

    const editList = { ...props.parentState.editOfficesList };
    editList[id]["edit"] = resolve.data.status !== "OK";
    editList[id]["editedName"] =
      resolve.data.status === "OK"
        ? props.parentState.editOfficesList[id]["name"]
        : "";
    editList[id]["formResponse"] = resolve.data;

    props.updateParentState({
      editOfficesList: editList,
    });
  };

  const getRedirectUrl = () => {
    setCardButtonDisabled(true);

    ApiManager.postRequest(
      {
        msisdn: props.parentState.accountData.data.number
          .replace(/^\+374|^74/g, "")
          .trim(),
        amount: 200,
        save_card: 1,
        _token: props.csrf_token.data,
        jwt: props.getDecryptedToken(),
      },
      "/payment/card/add"
    ).then((resolve) => {
      if (!isMounted.current) return;
      setCardButtonDisabled(false);

      if (resolve.data.status === "OK") {
        window.location = resolve.data.data.redirect_url;
      } else {
        addNotification(resolve.data.message, "danger");
      }
    }, errorCallBack);
  };

  const confirmAction = () => {
    props.updateParentState({
      editAccountDetachButtonLoading: true,
    });

    let url = "/account/detach";
    if (!props.parentState.editMyAttachments) {
      url = "/account/delete";
    }

    ApiManager.postRequest(
      {
        jwt: props.getDecryptedToken(),
        _token: props.csrf_token.data,
        id: props.parentState.editAccountDetachId,
      },
      url
    ).then(accountDetachSuccess, errorCallBack);
  };

  const accountDetachSuccess = (resolve) => {
    if (!isMounted.current) return;

    props.updateParentState({ editAccountDetachButtonLoading: false });
    setDetachModal(false);

    if (resolve.data.status === "OK") {
      const newParentState = { ...props.parentState.editAccountDetachIdList };
      newParentState[props.parentState.editAccountDetachId] = false;

      let count = 0;
      if (props.parentState.editMyAttachments) {
        count = props.parentState.editDetachRemovedCount + 1;
      }

      props.updateParentState({
        editAccountDetachIdList: newParentState,
        editDetachRemovedCount: count,
        editMyAttachments: true,
      });

      addNotification(trans(props.trans, "detach_modal.success.message"));
    } else {
      addNotification(
        trans(props.trans, "detach_modal.error.message"),
        "danger"
      );
    }
  };

  const cancelAction = () => {
    setDetachModal(false);
  };

  const detachAutoPaymentAction = () => {
    setAutoPaymentAskModalButtonDisabled(true);

    ApiManager.postRequest(
      { jwt: props.getDecryptedToken() },
      "/autopayment/detach"
    ).then(detachAutoPaymentSuccess, errorCallBack);
  };

  const detachAutoPaymentSuccess = () => {
    if (!isMounted.current) return;
    setAutoPaymentAskModalButtonDisabled(false);
    setAutoPaymentAskModal(false);
    setAutoPaymentList("");
    getAutoPaymentsList();
  };

  const deleteCardAction = () => {
    setPaymentCardDeleteModalButtonDisabled(true);

    ApiManager.postRequest(
      {
        jwt: props.getDecryptedToken(),
        _token: props.csrf_token.data,
        id: paymentCardDeleteId,
      },
      "/payment/card/delete"
    ).then(deleteCardSuccess, errorCallBack);
  };

  const deleteCardSuccess = () => {
    if (!isMounted.current) return;
    setPaymentCardDeleteModalButtonDisabled(false);
    setPaymentCardDeleteModalShow(false);
    setPaymentCardDeleteId(null);
    setPaymentCardList("");
    getCardList();
  };

  const sectionFirst = () => {
    let errorProfileNumberClass = "",
      errorProfileNumberBox = "",
      errorProfileEmailClass = "",
      errorProfileEmailBox = "",
      errorBox = "";

    if (profileFormResponse !== "") {
      if (profileFormResponse.status === "INVALID_DATA") {
        if (profileFormResponse.errors.hasOwnProperty("contact_number")) {
          errorProfileNumberClass = " form-error";
          errorProfileNumberBox = (
            <div className="form-error-text fs11">
              {profileFormResponse.errors.contact_number}
            </div>
          );
        }
        if (profileFormResponse.errors.hasOwnProperty("contact_email")) {
          errorProfileEmailClass = " form-error";
          errorProfileEmailBox = (
            <div className="form-error-text fs11">
              {profileFormResponse.errors.contact_email}
            </div>
          );
        }
      }

      if (profileFormResponse.status === "ERROR") {
        errorBox = (
          <FormMiddlewareError
            message={profileFormResponse.message}
            trans={props.trans}
          />
        );
      }
    }

    return (
      <section className="main-wrapper__services main-wrapper__services--with-shade main-wrapper__services--with-space">
        <h2 className="main-wrapper__sub-title main-wrapper__sub-title--edit-account monserrat-medium pr sprite-b move-cursor">
          {trans(props.trans, "account.edit.title")}
        </h2>

        <div className="main-wrapper__list-out">
          <ul className="list">
            <li className="list__item">
              <div className="list__link list__link--white-bg list__link--space-24">
                <form action="#" method="post" onSubmit={sendProfileData}>
                  <div className={`form__form-box${errorProfileNumberClass}`}>
                    <label className="form__label db fs11" htmlFor="tel-number">
                      {trans(props.trans, "account.edit.phone_label")}
                    </label>
                    <div className="form__field-out pr form__field-out--with-prefix">
                      <input
                        className="form__field fs13"
                        id="tel-number"
                        name="tel-number"
                        type="text"
                        style={{
                          paddingLeft: "10px",
                        }}
                        value={profileNumber}
                        onChange={(event) =>
                          setProfileNumber(
                            event.target.value.trim().replace(/[^\d]/g, "")
                          )
                        }
                      />
                    </div>
                    {errorProfileNumberBox}
                  </div>

                  <div className={`form__form-box${errorProfileEmailClass}`}>
                    <label className="form__label  db fs11" htmlFor="email">
                      {trans(props.trans, "account.edit.email_label")}
                    </label>
                    <div className="form__field-out pr">
                      <input
                        className="form__field fs13"
                        id="email"
                        type="text"
                        value={profileEmail}
                        onChange={(event) =>
                          setProfileEmail(event.target.value.trim())
                        }
                      />
                    </div>
                    {errorProfileEmailBox}
                  </div>

                  {errorBox}

                  <button
                    className={`form__registration-btn btn btn--white fs17${
                      profileButtonDisabled ? " btn--loading" : ""
                    }`}
                    type="submit"
                    disabled={profileData === "" || profileButtonDisabled}
                  >
                    {trans(props.trans, "account.edit.button_label")}
                  </button>
                </form>
              </div>
            </li>
          </ul>
        </div>
      </section>
    );
  };
  /*************  ✨ Windsurf Command ⭐  *************/
  /**
   * The component renders the section for changing the user's base data
   * @returns {ReactElement}
   */
  /*******  3e8291e4-513d-45b3-aac7-527cda91cc35  *******/

  const sectionSecond = () => {
    const passwordsCountIsValid =
      changePasswordNew.length >= changePasswordMinLength &&
      changePasswordRepeat.length >= changePasswordMinLength;

    let errorOldPasswordClass = "",
      errorOldPasswordBox = "",
      errorNewPasswordClass = "",
      errorNewPasswordBox = "",
      errorPasswordConfirmationClass = "",
      errorPasswordConfirmationBox = "",
      errorBox = "";

    if (changePasswordFormResponse !== "") {
      if (changePasswordFormResponse.status === "INVALID_DATA") {
        if (changePasswordFormResponse.errors.hasOwnProperty("old_password")) {
          errorOldPasswordClass = " form-error";
          errorOldPasswordBox = (
            <div className="form-error-text fs11">
              {changePasswordFormResponse.errors.old_password}
            </div>
          );
        }
        if (changePasswordFormResponse.errors.hasOwnProperty("password")) {
          errorNewPasswordClass = " form-error";
          errorNewPasswordBox = (
            <div className="form-error-text fs11">
              {changePasswordFormResponse.errors.password}
            </div>
          );
        }
        if (
          changePasswordFormResponse.errors.hasOwnProperty(
            "password_confirmation"
          )
        ) {
          errorPasswordConfirmationClass = " form-error";
          errorPasswordConfirmationBox = (
            <div className="form-error-text fs11">
              {changePasswordFormResponse.errors.password_confirmation}
            </div>
          );
        }
        if (changePasswordFormResponse.errors.hasOwnProperty("token")) {
          errorBox = (
            <FormMiddlewareError
              message={changePasswordFormResponse.errors.token}
            />
          );
        }
      }

      if (changePasswordFormResponse.status === "ERROR") {
        errorBox = (
          <FormMiddlewareError
            message={changePasswordFormResponse.message}
            trans={props.trans}
          />
        );
      }
    }

    return (
      <section className="main-wrapper__services main-wrapper__services--with-shade main-wrapper__services--with-space">
        <h2 className="main-wrapper__sub-title main-wrapper__sub-title--lock monserrat-medium pr sprite-b move-cursor">
          {trans(props.trans, "account.change_password.title")}
        </h2>

        <div className="main-wrapper__list-out">
          <ul className="list">
            <li className="list__item">
              <div className="list__link list__link--white-bg list__link--space-24">
                <form action="#" method="post" onSubmit={changePasswordAction}>
                  <div className={`form__form-box${errorOldPasswordClass}`}>
                    <label
                      className="form__label db fs11"
                      htmlFor="old-password"
                    >
                      {trans(props.trans, "account.change_password.old_label")}
                    </label>
                    <div className="form__field-out pr">
                      <input
                        className="form__field fs13"
                        id="old-password"
                        name="old-password"
                        type={isShowOldPassword ? "text" : "password"}
                        value={changePasswordOld}
                        onChange={(event) =>
                          setChangePasswordOld(event.target.value.trim())
                        }
                      />
                      <EyeComponent
                        isShow={isShowOldPassword}
                        eyeHandler={() => setIsShowOldPassword((prev) => !prev)}
                      />
                    </div>
                    {errorOldPasswordBox}
                  </div>

                  <div className={`form__form-box${errorNewPasswordClass}`}>
                    <label
                      className="form__label  db fs11"
                      htmlFor="new-password"
                    >
                      {trans(props.trans, "account.change_password.new_label")}
                    </label>
                    <div className="form__field-out pr">
                      <input
                        className="form__field fs13"
                        id="new-password"
                        name="new-password"
                        type={isShowNewPassword ? "text" : "password"}
                        value={changePasswordNew}
                        onChange={(event) =>
                          setChangePasswordNew(event.target.value.trim())
                        }
                      />
                      <EyeComponent
                        isShow={isShowNewPassword}
                        eyeHandler={() => setIsShowNewPassword((prev) => !prev)}
                      />
                    </div>
                    {errorNewPasswordBox}
                  </div>

                  <div
                    className={`form__form-box${errorPasswordConfirmationClass}`}
                  >
                    <label
                      className="form__label  db fs11"
                      htmlFor="password-confirmation"
                    >
                      {trans(
                        props.trans,
                        "account.change_password.repeat_label"
                      )}
                    </label>
                    <div className="form__field-out pr">
                      <input
                        className="form__field fs13"
                        id="password-confirmation"
                        name="password-confirmation"
                        type={isShowRepeatPassword ? "text" : "password"}
                        value={changePasswordRepeat}
                        onChange={(event) =>
                          setChangePasswordRepeat(event.target.value.trim())
                        }
                      />
                      <EyeComponent
                        isShow={isShowRepeatPassword}
                        eyeHandler={() =>
                          setIsShowRepeatPassword((prev) => !prev)
                        }
                      />
                    </div>
                    {errorPasswordConfirmationBox}
                  </div>

                  {errorBox}

                  <button
                    className={`form__registration-btn btn btn--white fs17${
                      changePasswordButtonDisabled ? " btn--loading" : ""
                    }`}
                    type="submit"
                    disabled={
                      !passwordsCountIsValid || changePasswordButtonDisabled
                    }
                  >
                    {trans(props.trans, "account.change_password.button_label")}
                  </button>
                </form>
              </div>
            </li>
          </ul>
        </div>
      </section>
    );
  };

  const sectionThird = () => {
    if (props.parentState.accountList === "") {
      return (
        <div className="loading-box pr">
          <div className="loading"></div>
        </div>
      );
    }

    if (
      props.parentState.accountList !== "" &&
      props.parentState.accountList.status === "ERROR"
    ) {
      return (
        <section className="main-wrapper__services main-wrapper__services--with-shade main-wrapper__services--with-space">
          <h2 className="main-wrapper__sub-title main-wrapper__sub-title--profile monserrat-medium pr sprite-b move-cursor">
            {trans(props.trans, "account.main_office.title")}
          </h2>
          <p className="error-message">
            {props.parentState.accountList.message}
          </p>
        </section>
      );
    }

    let attachedWrapper = "";
    const attachedItemsCount =
      props.parentState.accountList.data.attached_to.length -
      props.parentState.editDetachRemovedCount;

    const myNumberTitle =
      props.parentState.editedMyAccountName ||
      props.parentState.accountList.data.main_account_name;

    let myNumber = (
      <li className="list__item pr">
        <div className="list__link list__link--white-bg">
          <h2 className="main-wrapper__info-box-title">{myNumberTitle}</h2>
          <ul className="main-wrapper__info-list">
            <li className="main-wrapper__info-list-item ver-top-box fb">
              {props.parentState.accountList.data.main_account.includes("@")
                ? props.parentState.accountList.data.main_account
                : "+374" +
                  setSpaceAfterNLetter(
                    props.parentState.accountList.data.main_account,
                    2
                  )}
            </li>
          </ul>
        </div>
        <div className="list__icon-box pa">
          <div className="list__btn-out ver-top-box">
            <button
              className="list__edit-btn ver-top-box sprite"
              type="button"
              title={trans(props.trans, "global.edit.title")}
              onClick={() =>
                props.updateParentState({
                  editMyAccount: true,
                  editMyAccountName: myNumberTitle,
                })
              }
            >
              {" "}
            </button>
          </div>
        </div>
      </li>
    );

    if (props.parentState.editMyAccount) {
      myNumber = (
        <EditForm
          prefix="my-number-edit"
          value={props.parentState.editMyAccountName}
          onChange={(event) =>
            props.updateParentState({
              editMyAccountName: event.target.value,
            })
          }
          submit={changeMyAccountName}
          cancel={() =>
            props.updateParentState({
              editMyAccount: false,
              editMyAccountName: props.parentState.editedMyAccountName,
              editMyAccountNameResponse: "",
            })
          }
          editMyAccountNameResponse={
            props.parentState.editMyAccountNameResponse
          }
        />
      );
    }

    if (attachedItemsCount === 1) {
      attachedWrapper = (
        <div className="main-wrapper__list-out">
          <ul className="list list--inner list--numbers">
            {myNumber}
            <li className="list__item pr">
              <div className="list__link list__link--white-bg">
                <h2 className="main-wrapper__info-box-title main-wrapper__info-box-title--red">
                  {trans(
                    props.trans,
                    "account.main_office.single_title_start"
                  ) +
                    " " +
                    setSpaceAfterNLetter(
                      props.parentState.accountList.data.attached_to[0].number,
                      2
                    ) +
                    " " +
                    trans(props.trans, "account.main_office.single_title_end")}
                </h2>
              </div>
              <div className="list__icon-box pa">
                <div className="list__btn-out ver-top-box">
                  <button
                    className="list__delete-btn ver-top-box sprite"
                    type="button"
                    title={trans(props.trans, "global.detach.title")}
                    onClick={() => {
                      const currentList =
                        props.parentState.accountList.data.attached_to;
                      let current = null;

                      for (let i in currentList) {
                        if (
                          !props.parentState.editAccountDetachIdList.hasOwnProperty(
                            currentList[i]["id"]
                          ) ||
                          (props.parentState.editAccountDetachIdList.hasOwnProperty(
                            currentList[i]["id"]
                          ) &&
                            props.parentState.editAccountDetachIdList[
                              currentList[i]["id"]
                            ])
                        ) {
                          current = currentList[i];
                          break;
                        }
                      }

                      setDetachModal(true);
                      setDetachNumber1(
                        props.parentState.accountList.data.main_account
                      );
                      setDetachNumber2(current["number"]);

                      const newIdToParentState = {
                        ...props.parentState.editAccountDetachIdList,
                      };
                      const currentId = current["id"];
                      newIdToParentState[currentId] = true;

                      props.updateParentState({
                        editAccountDetachIdList: newIdToParentState,
                        editAccountDetachId: currentId,
                      });
                    }}
                  >
                    {" "}
                  </button>
                </div>
              </div>
            </li>
          </ul>
        </div>
      );
    } else if (attachedItemsCount > 1) {
      const attachedItems = props.parentState.accountList.data.attached_to.map(
        (item, index) => {
          if (
            props.parentState.editAccountDetachIdList.hasOwnProperty(item.id) &&
            !props.parentState.editAccountDetachIdList[item.id]
          ) {
            return null;
          }
          const date = new Date(item.updated_at);

          return (
            <li className="list__item pr" key={index}>
              <div className="list__link db">
                <h2 className="main-wrapper__info-box-title fb">
                  {trans(
                    props.trans,
                    "account.main_office.single_title_start"
                  ) +
                    " " +
                    setSpaceAfterNLetter(item.number, 2) +
                    " " +
                    trans(props.trans, "account.main_office.single_title_end")}
                </h2>
                <ul className="main-wrapper__info-list">
                  <li className="main-wrapper__info-list-item ver-top-box">
                    {doubleNumber(date.getMonth() + 1) +
                      "/" +
                      date.getFullYear().toString().substr(-2)}
                  </li>
                </ul>
              </div>
              <div className="list__icon-box pa">
                <div className="list__btn-out ver-top-box">
                  <button
                    className="list__delete-btn ver-top-box sprite"
                    type="button"
                    title={trans(props.trans, "global.detach.title")}
                    onClick={() => {
                      setDetachModal(true);
                      setDetachNumber1(
                        props.parentState.accountList.data.main_account
                      );
                      setDetachNumber2(item["number"]);

                      const newIdToParentState = {
                        ...props.parentState.editAccountDetachIdList,
                      };
                      const currentId = item["id"];
                      newIdToParentState[currentId] = true;

                      props.updateParentState({
                        editAccountDetachIdList: newIdToParentState,
                        editAccountDetachId: currentId,
                        editMyAttachments: true,
                      });
                    }}
                  >
                    {" "}
                  </button>
                </div>
              </div>
            </li>
          );
        }
      );

      let listAttached = null;
      if (toggleAttachedNumbers) {
        listAttached = (
          <div className="main-wrapper__list-out">
            <ul className="list list--inner list--attached">{attachedItems}</ul>
          </div>
        );
      }

      attachedWrapper = (
        <>
          <div className="main-wrapper__list-out">
            <ul className="list list--inner list--numbers">
              {myNumber}
              <li className="list__item dn"> </li>
            </ul>
          </div>
          <button
            className={`main-wrapper__info-box-title
              main-wrapper__info-box-title--tab-button
              ${
                toggleAttachedNumbers
                  ? "main-wrapper__info-box-title--tab-button-active"
                  : ""
              }
              main-wrapper__info-box-title--red
              sprite-a pr tl`}
            type="button"
            onClick={() => setToggleAttachedNumbers(!toggleAttachedNumbers)}
          >
            {trans(props.trans, "account.attached_to_offices.title")}
          </button>
          {listAttached}
        </>
      );
    } else {
      attachedWrapper = (
        <div className="main-wrapper__list-out">
          <ul className="list list--inner list--numbers">{myNumber}</ul>
        </div>
      );
    }

    return (
      <section className="main-wrapper__services main-wrapper__services--with-shade main-wrapper__services--with-space">
        <h2 className="main-wrapper__sub-title main-wrapper__sub-title--profile monserrat-medium pr sprite-b move-cursor">
          {trans(props.trans, "account.main_office.title")}
        </h2>
        {attachedWrapper}
      </section>
    );
  };

  const sectionFourth = () => {
    if (props.parentState.accountList === "") {
      return (
        <div className="loading-box pr">
          <div className="loading"></div>
        </div>
      );
    }

    if (
      props.parentState.accountList !== "" &&
      props.parentState.accountList.status === "ERROR"
    ) {
      return (
        <section className="main-wrapper__services main-wrapper__services--with-shade main-wrapper__services--bottom-inner-space">
          <h2 className="main-wrapper__sub-title main-wrapper__sub-title--profile-double monserrat-medium pr sprite-b move-cursor">
            {trans(props.trans, "account.other_office.title")}
          </h2>
          <p className="error-message pb-none">
            {props.parentState.accountList.message}
          </p>
        </section>
      );
    }

    const accountItems = props.parentState.accountList.data.accounts.map(
      (item, index) => {
        if (
          props.parentState.editAccountDetachIdList.hasOwnProperty(item.id) &&
          !props.parentState.editAccountDetachIdList[item.id]
        ) {
          return null;
        }

        let current = "";
        let currentTitle =
          props.parentState.editOfficesList[item.id] &&
          props.parentState.editOfficesList[item.id]["editedName"]
            ? props.parentState.editOfficesList[item.id]["editedName"]
            : item.name;

        if (item.is_current) {
          current = (
            <div className="list__btn-out ver-top-box">
              <button
                className="list__agree-btn ver-top-box sprite"
                type="button"
                disabled={true}
              >
                {" "}
              </button>
            </div>
          );
        }

        if (
          props.parentState.editOfficesList[item.id] &&
          props.parentState.editOfficesList[item.id]["edit"]
        ) {
          return (
            <EditForm
              key={index}
              prefix={`office-edit-${item.id}`}
              value={props.parentState.editOfficesList[item.id]["name"]}
              onChange={(event) => {
                const editList = { ...props.parentState.editOfficesList };
                editList[item.id]["name"] = event.target.value;
                props.updateParentState({ editOfficesList: editList });
              }}
              submit={(event) => changeOfficeName(event, item.id)}
              cancel={() => {
                const editList = { ...props.parentState.editOfficesList };
                editList[item.id]["edit"] = false;
                editList[item.id]["name"] =
                  props.parentState.editOfficesList[item.id]["editedName"];
                editList[item.id]["formResponse"] = "";

                props.updateParentState({
                  editOfficesList: editList,
                });
              }}
              editMyAccountNameResponse={
                props.parentState.editOfficesList[item.id]["formResponse"]
              }
            />
          );
        }

        return (
          <li className="list__item pr" key={index}>
            <div
              className={`list__link list__link--white-bg${
                item.is_current ? " list__link--highlighted" : ""
              }`}
            >
              <h2 className="main-wrapper__info-box-title">{currentTitle}</h2>
              <ul className="main-wrapper__info-list">
                <li className="main-wrapper__info-list-item ver-top-box fb">
                  +374 {setSpaceAfterNLetter(item.number, 2)}
                </li>
              </ul>
            </div>
            <div className="list__icon-box pa">
              {current}
              <div className="list__btn-out ver-top-box">
                <button
                  className="list__edit-btn ver-top-box sprite"
                  type="button"
                  title={trans(props.trans, "global.edit.title")}
                  onClick={() => {
                    const editList = { ...props.parentState.editOfficesList };
                    editList[item.id]["edit"] = true;
                    editList[item.id]["name"] = currentTitle;
                    props.updateParentState({
                      editOfficesList: editList,
                    });
                  }}
                >
                  {" "}
                </button>
              </div>
              <div className="list__btn-out ver-top-box">
                <button
                  className="list__delete-btn ver-top-box sprite"
                  type="button"
                  title={trans(props.trans, "global.detach.title")}
                  onClick={() => {
                    setDetachModal(true);
                    setDetachNumber1(
                      props.parentState.accountList.data.main_account
                    );
                    setDetachNumber2(item["number"]);

                    const newIdToParentState = {
                      ...props.parentState.editAccountDetachIdList,
                    };
                    const currentId = item["id"];
                    newIdToParentState[currentId] = true;

                    props.updateParentState({
                      editAccountDetachIdList: newIdToParentState,
                      editAccountDetachId: currentId,
                      editMyAttachments: false,
                    });
                  }}
                >
                  {" "}
                </button>
              </div>
            </div>
          </li>
        );
      }
    );

    return (
      <section className="main-wrapper__services main-wrapper__services--with-shade main-wrapper__services--bottom-inner-space">
        <h2 className="main-wrapper__sub-title main-wrapper__sub-title--profile-double monserrat-medium pr sprite-b move-cursor">
          {trans(props.trans, "account.other_office.title")}
        </h2>

        <div className="main-wrapper__list-out">
          <ul className="list list--inner list--number-tools">
            {accountItems}
          </ul>

          <Link
            className="btn btn--white db"
            to={config.urlPrefix + props.parentState.urlPrefix + "/add-office"}
          >
            {trans(props.trans, "account.other_office.button_title")}
          </Link>
        </div>
      </section>
    );
  };

  const sectionFifth = () => {
    let listItems = (
      <div className="loading-box pr">
        <div className="loading"></div>
      </div>
    );

    if (paymentCardList !== "" && paymentCardList.status === "OK") {
      if (paymentCardList.data.cards.length) {
        listItems = paymentCardList.data.cards.map((item, index) => {
          let defaultCard = null;
          if (index === 0) {
            defaultCard = (
              <span className="list__btn-out ver-top-box">
                <span className="list__agree-btn ver-top-box sprite"></span>
              </span>
            );
          }

          return (
            <li className="list__item pr" key={index}>
              <div
                className={`list__link list__link--white-bg${
                  index === 0 ? " list__link--highlighted" : ""
                }`}
              >
                <span className="main-wrapper__info-box-title db fb">
                  {item.pan}
                </span>
                <span className="main-wrapper__info-list">
                  <span className="main-wrapper__info-list-item ver-top-box fs14">
                    {item.expiration_date}
                  </span>
                </span>
                <span className="list__icon-box db pa">
                  {defaultCard}
                  <span className="list__btn-out ver-top-box">
                    <button
                      className="list__delete-btn sprite"
                      type="button"
                      title={trans(props.trans, "account.card.delete_title")}
                      onClick={() => {
                        setPaymentCardDeleteId(item.id);
                        setPaymentCardDeleteModalShow(true);
                      }}
                    ></button>
                  </span>
                </span>
              </div>
            </li>
          );
        });
      } else {
        listItems = (
          <li className="list__item">
            <div className="list__link">
              {trans(props.trans, "empty.message")}
            </div>
          </li>
        );
      }

      listItems = (
        <ul className="list list--inner list--number-tools list--cards">
          {listItems}
        </ul>
      );
    }

    if (
      paymentCardList !== "" &&
      (paymentCardList.status === "ERROR" ||
        paymentCardList.status === "NOT_FOUND")
    ) {
      listItems = (
        <p className="error-message error-message--without-lr-padding">
          {paymentCardList.message}
        </p>
      );
    }

    let addCardButton = null;
    if (config.env !== "production") {
      addCardButton = (
        <button
          className={`btn btn--white db${
            cardButtonDisabled ? " btn--loading" : ""
          }`}
          type="button"
          disabled={cardButtonDisabled}
          onClick={getRedirectUrl}
        >
          {trans(props.trans, "account.cards.button")}
        </button>
      );
    }

    return (
      <section className="main-wrapper__services main-wrapper__services--with-shade main-wrapper__services--bottom-inner-space main-wrapper__services--with-space">
        <h2 className="main-wrapper__sub-title main-wrapper__sub-title--card monserrat-medium pr sprite-b move-cursor">
          {trans(props.trans, "account.cards.title")}
        </h2>

        <div className="main-wrapper__list-out">
          {listItems}
          {addCardButton}
        </div>
      </section>
    );
  };

  const sectionSixth = () => {
    if (config.env === "production") {
      return null;
    }

    let listItems = <Loading withBox={true} />;
    let detachItem = null;

    if (autoPaymentList !== "" && autoPaymentList.status === "OK") {
      if (autoPaymentList.data.my_autopayments.length) {
        listItems = autoPaymentList.data.my_autopayments.map((item, index) => {
          return (
            <li className="list__item pr" key={index}>
              <Link
                className="list__link db sprite-a pr"
                to={
                  config.urlPrefix +
                  props.parentState.urlPrefix +
                  "/editAutoPayment"
                }
                onClick={() => {
                  localStorageSetItem("editAutoPaymentId", item.id);
                }}
              >
                <span className="main-wrapper__info-box-title db fs14 three-dots-in-one-line no-wrap">
                  {item.name || props.parentState.accountData.data.number}
                </span>
                <span className="main-wrapper__info-list db">
                  <span className="main-wrapper__info-list-item ver-top-box fb">
                    +374 {setSpaceAfterNLetter(item.phone_number, 2)}
                  </span>
                </span>
              </Link>
              {/*
                If you want to enable a delete button for autopayments:
                <button
                  className="list__delete-btn sprite"
                  type="button"
                  title={trans(props.trans, 'account.periodic_payments.delete.title')}
                  onClick={() => setAutoPaymentAskModal(true)}
                ></button>
              */}
            </li>
          );
        });
      } else {
        listItems = (
          <li className="list__item">
            <div className="list__link">
              {trans(props.trans, "empty.message")}
            </div>
          </li>
        );
      }

      if (autoPaymentList.data.attached_to !== null) {
        detachItem = (
          <li className="list__item pr">
            <div className="list__link list__link--white-bg">
              <h2 className="main-wrapper__info-box-title main-wrapper__info-box-title--red">
                {trans(
                  props.trans,
                  "account.autopayment.number.attached_to.text"
                ).replace(/%s/, autoPaymentList.data.attached_to)}
              </h2>
            </div>
            <div className="list__icon-box pa">
              <div className="list__btn-out ver-top-box">
                <button
                  className="list__delete-btn ver-top-box sprite"
                  type="button"
                  title={trans(
                    props.trans,
                    "account.autopayment.number.attached_to.hint"
                  )}
                  onClick={() => setAutoPaymentAskModal(true)}
                ></button>
              </div>
            </div>
          </li>
        );

        if (autoPaymentList.data.my_autopayments.length === 0) {
          listItems = null;
        }
      }

      listItems = (
        <ul className="list list--inner list--number-tools list--periodic-payments">
          {listItems}
          {detachItem}
        </ul>
      );
    }

    if (
      autoPaymentList !== "" &&
      (autoPaymentList.status === "ERROR" ||
        autoPaymentList.status === "NOT_FOUND")
    ) {
      listItems = (
        <p className="error-message error-message--without-lr-padding">
          {autoPaymentList.message}
        </p>
      );
    }

    return (
      <section className="main-wrapper__services main-wrapper__services--with-shade main-wrapper__services--bottom-inner-space">
        <h2 className="main-wrapper__sub-title main-wrapper__sub-title--refresh monserrat-medium pr sprite-b move-cursor">
          {trans(props.trans, "account.periodic_payments.title")}
        </h2>

        <div className="main-wrapper__list-out">
          {listItems}

          <Link
            className="btn btn--white db"
            onClick={() => localStorageRemoveItem("editAutoPaymentId")}
            to={
              config.urlPrefix + props.parentState.urlPrefix + "/addAutoPayment"
            }
          >
            {trans(props.trans, "account.periodic_payments.button")}
          </Link>
        </div>
      </section>
    );
  };

  const sectionSeventh = () => {
    let errorProfileNumberClass = "",
      errorProfileNumberBox = "",
      errorProfileEmailClass = "",
      errorProfileEmailBox = "",
      errorBox = "";

    if (profileFormResponse !== "") {
      if (profileFormResponse.status === "INVALID_DATA") {
        if (profileFormResponse.errors.hasOwnProperty("contact_number")) {
          errorProfileNumberClass = " form-error";
          errorProfileNumberBox = (
            <div className="form-error-text fs11">
              {profileFormResponse.errors.contact_number}
            </div>
          );
        }
        if (profileFormResponse.errors.hasOwnProperty("contact_email")) {
          errorProfileEmailClass = " form-error";
          errorProfileEmailBox = (
            <div className="form-error-text fs11">
              {profileFormResponse.errors.contact_email}
            </div>
          );
        }
      }

      if (profileFormResponse.status === "ERROR") {
        errorBox = (
          <FormMiddlewareError
            message={profileFormResponse.message}
            trans={props.trans}
          />
        );
      }
    }
    return (
      <section className="main-wrapper__services main-wrapper__services--with-shade main-wrapper__services--with-space">
        <h2 className="main-wrapper__sub-title main-wrapper__sub-title--edit-account monserrat-medium pr sprite-b move-cursor">
          {trans(props.trans, "account.change_main_data")}
        </h2>

        <div className="main-wrapper__list-out">
          <ul className="list">
            <li className="list__item">
              <div className="list__link list__link--white-bg list__link--space-24">
                <div>
                  {isShowVerificationOPT ? (
                    <div>
                      <label className="form__label db fs11" htmlFor="code">
                        {trans(props.trans, "auth.register.phone.sms.title")}
                      </label>
                      <OTPInput
                        fields={6}
                        id="code"
                        containerClassName="otp-input"
                        type="text"
                        name="code"
                        value={""}
                        onChange={(event) => {
                          setVerificationCode(
                            event.trim().replace(/[^\d]/g, "")
                          );
                        }}
                      />
                      
                      {verificationErrors["code"] && (
                        <div
                          style={{
                            color: "red",
                            marginTop: "5px",
                            fontSize: "12px",
                          }}
                        >
                          {verificationErrors?.["code"]}
                        </div>
                      )}

                      {verificationTimeLife > -1 && (
                        <>
                          <div className="form__form-box form__form-box--with-space form-box">
                            <div className="form__time fs41 tc">
                              {lifeTimeConvert(verificationTimeLife)}
                            </div>
                          </div>
                          {/* <div className="form__desc-txt fs13">
                            {trans(
                              props.trans,
                              "auth.register.phone.sms.description"
                            )}
                          </div> */}
                        </>
                      )}

                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                        }}
                      >
                        <button
                          style={{
                            marginTop: "10px",
                            padding: "10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          className={`form__registration-btn btn btn--white fs17${
                            changePasswordButtonDisabled ? " btn--loading" : ""
                          }`}
                          onClick={() => {
                            setVerificationErrors({});
                            setIsShowVerificationOPT(false);
                            setVerificationTimeLife(-1);
                          }}
                        >
                          {trans(
                            props.trans,
                            "auth.forgot.password.button.cancel"
                          )}
                        </button>
                        <button
                          style={{
                            marginTop: "10px",
                            padding: "10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          className={`form__registration-btn btn btn--white fs17${
                            changePasswordButtonDisabled ? " btn--loading" : ""
                          }`}
                          onClick={() => {
                            if (currentVerificationField === "number") {
                              verificationHandlerSubmit().then((res) => {
                                if (res.data.status === "OK") {
                                  addNotification(
                                    trans(
                                      props.trans,
                                      "verification.successful.number.description"
                                    )
                                  );
                                  setIsShowVerificationOPT(false);
                                  setTimeout(() => {
                                    window.location.reload();
                                  }, 2000);
                                } else {
                                  setVerificationErrors({
                                    ...verificationErrors,
                                    code:
                                      res?.data?.errors?.code ||
                                      res?.data?.message,
                                  });
                                }
                              });
                            } else if (currentVerificationField === "email") {
                              emailVerificationHandlerSubmit().then((res) => {
                                if (res.data.status === "OK") {
                                  setTimeout(() => {
                                    window.location.reload();
                                  }, 2000);
                                  addNotification(
                                    trans(
                                      props.trans,
                                      "verification.successful.email.description"
                                    )
                                  );
                                  setIsShowVerificationOPT(false);
                                } else {
                                  setVerificationErrors({
                                    ...verificationErrors,
                                    code:
                                      res?.data?.errors?.code ||
                                      res?.data?.message,
                                  });
                                }
                              });
                            }
                          }}
                        >
                          {trans(props.trans, "account.submit.title")}
                        </button>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div
                        className={`form__form-box${errorProfileNumberClass}`}
                      >
                        <label
                          className="form__label db fs11"
                          htmlFor="tel-number"
                        >
                          {trans(props.trans, "account.edit.phone_label")}
                        </label>
                        <div
                          className="form__field-out pr form__field-out--with-prefix verification_bloc_div"
                          style={{
                            gap: 0,
                          }}
                        >
                          <ArmenianFlagConst />
                          <input
                            style={{
                              border: "none",
                              borderRadius: "0",
                              borderBottom: "1px solid #ccc",
                              paddingLeft: "10px",
                            }}
                            value={usernameForVerification}
                            className="form__field fs13"
                            id="tel-number"
                            name="tel-number"
                            type="text"
                            onChange={(event) =>
                              setUsernameForVerification(
                                event.target.value.trim().replace(/[^\d]/g, "")
                              )
                            }
                          />
                          <button
                            className={`form__registration-btn btn verification_button btn--white fs17${
                              profileButtonDisabled ? " btn--loading" : ""
                            }`}
                            style={{
                              marginLeft: "10px",
                            }}
                            onClick={() => {
                              setVerificationErrors({});
                              verificationHandler().then((resolve) => {
                                if (resolve.data.status === "OK") {
                                  setCurrentVerificationField("number");
                                  setIsShowVerificationOPT(true);
                                  setCurrentToken(resolve?.data?.data?.token);
                                  const lifeSec =
                                  resolve?.data?.data?.time ?? 300;
                                  setVerificationTimeLife(lifeSec);
                                } else {
                                  setVerificationErrors({
                                    ...verificationErrors,
                                    number: resolve.data.errors.msisdn,
                                  });
                                }
                              }, errorCallBack);
                            }}
                            disabled={
                              profileData === "" || profileButtonDisabled
                            }
                          >
                            {trans(
                              props.trans,
                              "auth.forgot.password.button.title"
                            )}
                          </button>
                        </div>
                        <div
                          style={{
                            color: "red",
                            marginTop: "5px",
                            fontSize: "12px",
                          }}
                        >
                          {verificationErrors.number}
                        </div>
                      </div>
                      <div
                        className={`form__form-box${errorProfileEmailClass}`}
                      >
                        <label className="form__label  db fs11" htmlFor="email">
                          {trans(props.trans, "account.edit.email_label")}
                        </label>
                        <div className="form__field-out pr verification_bloc_div">
                          <input
                            className="form__field fs13"
                            id="email"
                            type="text"
                            value={userEmailForVerification}
                            onChange={(event) => {
                              setUserEmailForVerification(
                                event.target.value.trim()
                              );
                            }}
                          />
                          <button
                            className={`form__registration-btn btn btn--white verification_button fs17${
                              profileButtonDisabled ? " btn--loading" : ""
                            }`}
                            style={{
                              marginLeft: "10px",
                            }}
                            type="submit"
                            disabled={
                              profileData === "" || profileButtonDisabled
                            }
                            onClick={() => {
                              setVerificationErrors({});
                              emailVerifivationHandler().then((resolve) => {
                                if (resolve.data.status === "OK") {
                                  setCurrentVerificationField("email");
                                  setIsShowVerificationOPT(true);
                                  setCurrentToken(resolve?.data?.data?.token);
                                  const lifeSec =
                                    resolve?.data?.data?.time ?? 300;
                                  setVerificationTimeLife(lifeSec);
                                } else {
                                  setVerificationErrors({
                                    ...verificationErrors,
                                    email: resolve.data?.errors?.email,
                                  });
                                }
                              }, errorCallBack);
                            }}
                          >
                            {trans(
                              props.trans,
                              "auth.forgot.password.button.title"
                            )}
                          </button>
                        </div>
                        <div
                          style={{
                            color: "red",
                            marginTop: "5px",
                            fontSize: "12px",
                          }}
                        >
                          {verificationErrors.email}
                        </div>{" "}
                      </div>
                    </>
                  )}
                  {errorBox}
                </div>
              </div>
            </li>
          </ul>
        </div>
      </section>
    );
  };
  const detachModalElement = () => {
    if (!detachModal) return null;
    return (
      <DetachModal
        number1={detachNumber2}
        number2={detachNumber1}
        trans={props.trans}
        confirmAction={confirmAction}
        cancelAction={cancelAction}
        buttonLoading={props.parentState.editAccountDetachButtonLoading}
      />
    );
  };

  const errorModalElement = () => {
    if (!showErrorModal) return null;
    return (
      <ErrorModal
        title={trans(props.trans, "error.modal.title")}
        description={trans(props.trans, "error.modal.description")}
        action_text={trans(props.trans, "error.modal.action_text")}
      />
    );
  };

  const autoPaymentAskModalElement = () => {
    if (!autoPaymentAskModal) return null;
    return (
      <Modal
        title={trans(props.trans, "account.autopayment.detach_modal.title")}
        description={trans(
          props.trans,
          "account.autopayment.detach_modal.description"
        )}
        agreeText={trans(props.trans, "account.autopayment.detach_modal.agree")}
        cancelText={trans(
          props.trans,
          "account.autopayment.detach_modal.cancel"
        )}
        agreeAction={detachAutoPaymentAction}
        cancelAction={() => setAutoPaymentAskModal(false)}
        showCancelButton={true}
        confirmButtonDisabled={autoPaymentAskModalButtonDisabled}
        className="modal--full"
      />
    );
  };

  const cardDeleteModalElement = () => {
    if (!paymentCardDeleteModalShow) return null;
    return (
      <Modal
        title={trans(props.trans, "account.card.delete_modal.title")}
        description={trans(
          props.trans,
          "account.card.delete_modal.description"
        )}
        agreeText={trans(props.trans, "account.card.delete_modal.agree")}
        cancelText={trans(props.trans, "account.card.delete_modal.cancel")}
        agreeAction={deleteCardAction}
        cancelAction={() => {
          setPaymentCardDeleteModalShow(false);
          setPaymentCardDeleteId(null);
        }}
        showCancelButton={true}
        confirmButtonDisabled={paymentCardDeleteModalButtonDisabled}
        className="modal--full"
      />
    );
  };
  const notificationRender = () => {
    return <ReactNotification ref={notificationDOMRef} />;
  };

  const dndList = [
    <div className="row-drag-handle" key="first">
      {sectionFirst()}
    </div>,
    <div className="row-drag-handle" key="second">
      {sectionSecond()}
    </div>,
    <div className="row-drag-handle" key="third">
      {sectionThird()}
    </div>,
    <div className="row-drag-handle" key="fourth">
      {sectionFourth()}
    </div>,
    <div className="row-drag-handle" key="fifth">
      {sectionFifth()}
    </div>,
    <div className="row-drag-handle" key="sixth">
      {sectionSixth()}
    </div>,
    <div className="row-drag-handle" key="ninth">
      {sectionSeventh()}
    </div>,
  ];

  localStorageSetItem("accountDnd1", dnd1);
  localStorageSetItem("accountDnd2", dnd2);
  localStorageSetItem("accountDnd3", dnd3);
  useEffect(() => {
    if (verificationTimeLife <= -1) return;

    const timerId = setTimeout(() => {
      setVerificationTimeLife((prev) => prev - 1);
    }, 1000);

    return () => clearTimeout(timerId);
  }, [verificationTimeLife]);

  function lifeTimeConvert(seconds) {
    let minutes = Math.floor(seconds / 60);

    if (seconds / 60 < 1) {
      minutes = "00";
    }

    if (minutes < 10 && minutes > 0) {
      minutes = "0" + minutes;
    }

    if (seconds > 60) {
      seconds = seconds - minutes * 60;
    }

    if (seconds < 10) {
      seconds = "0" + seconds;
    }

    return minutes + ":" + seconds;
  }

  return (
    <div className="main-wrapper__third-list">
      {notificationRender()}
      <div className="main-wrapper__third-list-item ver-top-box">
        <Container
          orientation="vertical"
          dragHandleSelector=".main-wrapper__sub-title"
          dropPlaceholder={{ className: "box-drop-preview" }}
          groupName="1"
          getChildPayload={(i) => dnd1[i]}
          onDrop={(e) => setDnd1(applyDrag(dnd1, e))}
        >
          {dnd1.map((index) => (
            <Draggable key={index}>{dndList[index]}</Draggable>
          ))}
        </Container>
      </div>
      <div className="main-wrapper__third-list-item ver-top-box">
        <Container
          orientation="vertical"
          dragHandleSelector=".main-wrapper__sub-title"
          dropPlaceholder={{ className: "box-drop-preview" }}
          groupName="1"
          getChildPayload={(i) => dnd2[i]}
          onDrop={(e) => setDnd2(applyDrag(dnd2, e))}
        >
          {dnd2.map((index) => (
            <Draggable key={index}>{dndList[index]}</Draggable>
          ))}
        </Container>
      </div>
      <div className="main-wrapper__third-list-item ver-top-box">
        <Container
          orientation="vertical"
          dragHandleSelector=".main-wrapper__sub-title"
          dropPlaceholder={{ className: "box-drop-preview" }}
          groupName="1"
          getChildPayload={(i) => dnd3[i]}
          onDrop={(e) => setDnd3(applyDrag(dnd3, e))}
        >
          {dnd3.map((index) => (
            <Draggable key={index}>{dndList[index]}</Draggable>
          ))}
        </Container>
      </div>

      {autoPaymentAskModalElement()}
      {cardDeleteModalElement()}
      {detachModalElement()}
      {errorModalElement()}
    </div>
  );
}

export default Account;
